<template>
	<div class="container">
		<div class="col-md-12 mt-5">
			<div class="card shadow-sm border-0">
				<div class="card-header bg-white">
					<div class="d-flex justify-content-between align-items-center">
						<h5>Cursos</h5>
						<AddCourse />
					</div>
					<div class="modern-tabs mt-4">
						<button :class="['tab-btn', { active: activeTab === 'online' }]" @click="activeTab = 'online'">
							Online
						</button>
						<button :class="['tab-btn', { active: activeTab === 'presencial' }]" @click="activeTab = 'presencial'">
							Presenciales
						</button>
					</div>
				</div>

				<div class="card-body">
					<div v-if="!loading" class="table-responsive">
						<table class="table table-bordered table-hover">
							<thead>
								<tr>
									<th></th>
									<th>Posición</th>
									<th>Título</th>
									<th>Modalidad</th>
									<th>Estado</th>
									<th>Acciones</th>
								</tr>
							</thead>

							<draggable
								v-if="coursesByTab.length"
								v-model="coursesByTab"
								group="courses"
								item-key="UUID"
								@end="updateOrder"
								tag="tbody"
							>
								<template #item="{ element, index }">
									<CourseRow :course="element" :position="index + 1" />
								</template>
							</draggable>

							<tbody v-else>
								<tr>
									<td colspan="6" class="text-center text-muted">No hay cursos disponibles.</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-else class="text-center py-4">Cargando cursos...</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AddCourse from "@/components/Courses/AddCourse.vue";
import CourseRow from "@/components/Courses/CourseRow.vue";
import CourseService from "@/services/course.service.js";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

export default {
	components: { AddCourse, CourseRow, draggable },
	data() {
		return {
			loading: true,
			onlineCourses: [],
			onsiteCourses: [],
			activeTab: "online",
		};
	},
	computed: {
		coursesByTab: {
			get() {
				return this.activeTab === "online" ? this.onlineCourses : this.onsiteCourses;
			},
			set(newValue) {
				if (this.activeTab === "online") {
					this.onlineCourses = newValue;
				} else {
					this.onsiteCourses = newValue;
				}
			},
		},
	},
	methods: {
		async getCourses() {
			this.loading = true;
			const response = await CourseService.getAllCourses();
			const all = response.data;
			this.onlineCourses = all.filter((c) => c.isOnline);
			this.onsiteCourses = all.filter((c) => !c.isOnline);
			this.loading = false;
		},

		async updateOrder() {
			try {
				const targetList = this.coursesByTab;
				for (let i = 0; i < targetList.length; i++) {
					targetList[i].position = i + 1;
				}

				Swal.fire({
					title: "Guardando...",
					text: "Actualizando orden...",
					showConfirmButton: false,
					allowOutsideClick: false,
					didOpen: () => Swal.showLoading(),
				});

				await CourseService.updateCoursesOrder(
					targetList.map((c) => ({
						UUID: c.UUID,
						position: c.position,
					}))
				);

				await Swal.fire({
					icon: "success",
					title: "Orden actualizado",
					confirmButtonColor: "#0091ff",
				});
			} catch {
				await Swal.fire({
					icon: "error",
					title: "Error",
					text: "No se pudo actualizar el orden.",
					confirmButtonColor: "#d33",
				});
			}
		},
	},
	created() {
		this.getCourses();
	},
};
</script>
<style scoped>
.modern-tabs {
	display: flex;
	justify-content: center;
	gap: 1rem;
	margin-top: 1rem;
}

.tab-btn {
	background-color: #f1f5f9;
	color: #333;
	border: 2px solid transparent;
	border-radius: 12px;
	padding: 0.75rem 1.5rem;
	font-size: 1.1rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.tab-btn:hover {
	background-color: #e2e8f0;
}

.tab-btn.active {
	background-color: #0091ff;
	color: white;
	border-color: #0077cc;
	box-shadow: 0 3px 6px rgba(0, 145, 255, 0.3);
}
</style>
